<style  lang="scss" scoped>
.flex {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
}

.A1 {
    color: #1A1A1A;
}

.a {
    color: rgba(66, 94, 178, 1);
    cursor: pointer;
}

.el-form {
    margin-top: 17px;

    .grid {
        width: 100%;
        display: grid;
        grid-template-columns: 160px auto;
        grid-gap: 0 10px;
    }

    .grid-1 {
        @extend .grid;
        grid-template-columns: repeat(3, auto);

    }

    .el-select {
        width: 100%;
    }

    .select-2 {
        display: grid;
        grid-gap: 0 10px;
        grid-template-columns: repeat(2, auto);
        width: 100%;
    }

    .form-box {
        background: #F8F8F8;
        padding: 20px;
        padding-bottom: 2px;
        .top_baseline{
            align-items: baseline;
        }
        .name-tpis {
            padding-top: 7px;
            font-size: 14px;
            font-weight: 400;
            color: #7F7F7F;
            line-height: 21px;
        }
    }
}

.tips {
    height: 21px;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    line-height: 21px;
    margin-top: 7px;
}
.bottom_tips{
    padding-top: 6px;
    font-size: 14px;
    font-weight: 400;
    color: #7F7F7F;
    line-height: 21px;
}
</style>
<template>
    <el-drawer v-model="showDrawer" title="添加收款账户" size="600" :closeOnClickModal="false">
        <el-form :rules="rules" :model="form" ref="formRef" label-width="120" label-position="left">
            <div class="form-box">
                <el-form-item label-width="100" label="开户名称" class="top_baseline">
                    <div class="name">{{ state.name }}</div>
                    <div class="name-tpis">银行账户的开户名默认使用账号认证的名称，审核通过后不可修改</div>
                </el-form-item>
                <!-- <el-form-item label-width="100" label="证件类型">
                    {{ state.accountData.auth_cate_zh }}
                </el-form-item>
                <el-form-item label-width="100" label="证件号">
                    {{ state.accountData.auth_code }}
                </el-form-item> -->
                <el-form-item label-width="100" label="银行类型" prop="bank_type">
                    <el-select v-model="form.bank_type" placeholder="请选择开户银行">
                        <el-option v-for="item in state.bankList" :key="item.value" :label="`${item.name}`"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="100" label="银行卡号" prop="bank_card">
                    <el-input v-model="form.bank_card" placeholder="请输入开户银行卡号" @input="handlCardInput" 
                    :formatter="(value) =>`${value}`.replace(/\s/g, '').replace(/(\d{4})/g, '$1 ').trim()"
                    :parser="(value) => value.replace(/\$\s?|( *)/g, '')"/>
                </el-form-item>
                <el-form-item label-width="100" label="支行名称" prop="bank_branch">
                    <el-input v-model="form.bank_branch" placeholder="请输入开户支行名称" />
                </el-form-item>
                <el-form-item label-width="100" label="开户省市" prop="bank_province">
                    <div class="select-2">
                        <el-select placeholder="选择省／直辖市" v-model="form.bank_province" @change="changeProvince">
                            <el-option v-for="item in state.AddressData" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                        <el-select placeholder="城市／县区" v-model="form.bank_city" @change="changeCity">
                            <el-option v-for="item in state.AddressData1" :key="item.id" :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </el-form-item>
            </div>
            <div class="bottom_tips">绑卡须知：仅支持提现到已验证通过的银行卡，请尽快验证您的银行卡</div>
        </el-form>
        <template #footer>
            <el-button type="primary" @click.stop="create">保存</el-button>
        </template>
    </el-drawer>
</template>
  
<script setup>
import {
    // eslint-disable-next-line no-unused-vars
    ref,
    // eslint-disable-next-line no-unused-vars
    watch,
    onBeforeMount,
    // eslint-disable-next-line no-unused-vars
    onMounted,
    reactive,
    // eslint-disable-next-line no-unused-vars
    defineExpose,
    // eslint-disable-next-line no-unused-vars
    computed,
    onBeforeUnmount,
    defineProps,
    defineEmits
} from "vue";
import { getInvoicInfo, getAddressData, getBankList, createShroff } from '@/api/index';
// eslint-disable-next-line no-unused-vars
import { ElMessage, ElMessageBox } from "element-plus";
import tools from '@/utils/tools.js'
const props = defineProps(['show', 'id'])
const emit = defineEmits(['updateShow', 'delete'])
const form = ref({
    bank_type: '',
    bank_card: '',
    bank_branch: '',
    bank_province: '',
    bank_city: '',
    bank_province_str: '',
    bank_city_str: ''
})
const showDrawer = computed({
    get: () => props.show,
    set: (val) => {
        emit('updateShow', val)
    }
})
watch(() => props.show, () => {
    form.value.bank_type = ''
    form.value.bank_card = ''
    form.value.bank_branch = ''
    form.value.bank_province = ''
    form.value.bank_city = ''
    form.value.bank_province_str = ''
    form.value.bank_city_str = ''
})
onBeforeMount(async () => {
    getAddressDataFn()
    getinfo();
    getBankListData();
});
onBeforeUnmount(() => { });
const state = reactive({
    radio: '2',
    AddressData: [],
    AddressData1: [],
    auth_cate:'',
    name: '',
    id_card: '',
    bankList: []
})
const formRef = ref(null);
const create = async () => {
    formRef.value.validate(async (valid) => {
        if (valid) {
            if(!form.value.bank_city){
                ElMessage({
                    message: '请选择开户省市',
                    type: 'warning',
                })
                return false
            }
            const {status, message} = await createShroff({
                auth_cate:state.auth_cate,
                account_name:state.name,
                id_card:state.id_card,
                bank_type:form.value.bank_type,
                bank_card:form.value.bank_card.replace(/\$\s?|( *)/g, ''),
                bank_branch:form.value.bank_branch,
                bank_province:form.value.bank_province,
                bank_city:form.value.bank_city,
                bank_province_str:form.value.bank_province_str,
                bank_city_str:form.value.bank_city_str
            })
            if(status == 0){
                tools.confirm({
                    msg: message || '操作成功'
                },() => {
                    emit('updateShow')
                })
            }else{
                tools.confirm(message);
            }
        }
    });
}
// 认证信息
const getinfo = async () => {
    const {data} = await getInvoicInfo({})
    state.auth_cate = data.auth_cate
    state.name = data.auth_name
    state.id_card = data.auth_code
    // if(Number(data.auth_cate) == 11){
    //     state.name = data.person_auth_info.real_name
    //     state.id_card = data.person_auth_info.id_card
    // }else{
    //     state.name = data.company_auth_info.company_legal_real_name
    //     state.id_card = data.company_auth_info.company_legal_id_card
    // }
}
const getAddressDataFn = async () => {
    const { data } = await getAddressData({ json_type: 'json' })
    state.AddressData = data
}
const getBankListData = async () => {
    const {data} = await getBankList({})
    data.forEach(ele => {
        state.bankList.push({
            name:ele.bank_name,
            value:ele.bank_type
        })
    })
}
// 省市区
const changeProvince = event => {
    state.AddressData.forEach(e => {
        if (e.id === event) {
            state.AddressData1 = e.list
            form.value.bank_province_str = e.name
            form.value.bank_city = ''
            form.value.bank_city_str = ''
        }
    })
}
const changeCity = event => {
    state.AddressData1.forEach(e => {
        if (e.id === event) {
            form.value.bank_city_str = e.name
        }
    })
}
const rules = {
    bank_type: [
        { required: true, message: '请选择开户银行卡', trigger: 'change' }
    ],
    bank_card: [
        { required: true, message: '请输入银行卡号', trigger: 'blur' }
    ],
    bank_branch: [
        { required: true, message: '请输入支行名称', trigger: 'blur' }
    ],
    bank_province: [
        { required: true, message: '请选择开户省市', trigger: 'change' }
        // { validator: validateSelections, trigger: 'change' }
    ]
};
const handlCardInput = () => {
    // 移除所有非数字和空格的输入
    form.value.bank_card = form.value.bank_card.replace(/[^0-9\s]/g, '');
}
// const validateSelections = (rule, value, callback) => {
//     if (!form.value.bank_province || !form.value.bank_city) {
//         callback(new Error('请选择开户省市'));
//     } else {
//         callback();
//     }
// };
</script>

  